export const NAVIGATE_TO = 'router/NAVIGATE_TO'

export type NavigateTo = {
  type: typeof NAVIGATE_TO
  payload: {
    path: string
  }
}
